<template>
  <div class="gx-wb">
    <!-- 侧栏 -->
    <aside class="gx-wb__sidebar">
      <button class="gx-wb__logo" @click="$router.push('/ucenter')">
        <span class="gx-wb__logo-icon">🌳</span>
        <span class="gx-wb__logo-name">观星树</span>
      </button>

      <div class="gx-wb__user">
        <div class="gx-wb__user-row">
          <span class="gx-wb__user-avatar">
            <img v-if="userinfo.avatar" :src="userinfo.avatar" alt="" />
            <template v-else>{{ avatarText }}</template>
          </span>
          <div class="gx-wb__user-info">
            <div class="gx-wb__user-name">Hi，{{ userinfo.nickname || userinfo.name || userinfo.mobile || '商家用户' }}</div>
            <span class="gx-wb__user-level">{{ levelText }}</span>
          </div>
        </div>
        <div class="gx-wb__power">
          <span class="gx-wb__power-label">算力余额</span>
          <span class="gx-wb__power-val">{{ power }}</span>
        </div>
      </div>

      <div class="gx-wb__nav">
        <div v-for="group in navGroups" :key="group.title" class="gx-wb__group">
          <div class="gx-wb__group-title">{{ group.title }}</div>
          <button
            v-for="item in group.items"
            :key="item.id"
            class="gx-wb__item"
            :class="{ 'gx-wb__item--on': activeId === item.id }"
            @click="go(item)"
          >
            <span class="gx-wb__item-icon" v-html="item.icon"></span>
            {{ item.label }}
          </button>
        </div>
      </div>

      <button class="gx-wb__logout" @click="logout">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 14H3a1 1 0 01-1-1V3a1 1 0 011-1h3M11 11l3-3-3-3M14 8H6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        退出登录
      </button>
    </aside>

    <!-- 顶栏 -->
    <header class="gx-wb__topbar">
      <div class="gx-wb__crumb">
        <span>{{ crumbGroup }}</span>
        <span class="gx-wb__crumb-arrow">›</span>
        <span class="gx-wb__crumb-current">{{ crumbItem }}</span>
      </div>
      <div class="gx-wb__top-actions">
        <button class="gx-wb__icon-btn" title="搜索">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="8" cy="8" r="5" stroke="currentColor" stroke-width="1.3" /><path d="M13 13l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" /></svg>
        </button>
        <div class="gx-wb__bell-wrap">
          <button class="gx-wb__icon-btn" title="通知" @click="notifOpen = !notifOpen">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 2a6 6 0 016 6v3l1.5 2H1.5L3 11V8a6 6 0 016-6z" stroke="currentColor" stroke-width="1.3" /><path d="M7 15a2 2 0 004 0" stroke="currentColor" stroke-width="1.3" /></svg>
            <span v-if="unreadCount > 0" class="gx-wb__bell-badge">{{ unreadCount }}</span>
          </button>
          <div v-if="notifOpen" class="gx-wb__notif">
            <div class="gx-wb__notif-head">
              <span>通知</span>
              <button @click="notifOpen = false">✕</button>
            </div>
            <div v-if="notifs.length" class="gx-wb__notif-list">
              <div v-for="(n, i) in notifs.slice(0, 5)" :key="i" class="gx-wb__notif-item">
                <span class="gx-wb__notif-dot"></span>
                <div>
                  <div class="gx-wb__notif-text">{{ n.content || n.message || n.title }}</div>
                  <div class="gx-wb__notif-time">{{ n.created_at || '' }}</div>
                </div>
              </div>
            </div>
            <div v-else class="gx-wb__notif-empty">暂无通知</div>
            <button class="gx-wb__notif-all" @click="go({ route: '/notification' })">查看全部通知</button>
          </div>
        </div>
        <button class="gx-wb__icon-btn" title="设置" @click="go({ route: '/uc_setting' })">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="2.5" stroke="currentColor" stroke-width="1.3" /><path d="M9 1v2M9 15v2M1 9h2M15 9h2M3.2 3.2l1.4 1.4M13.4 13.4l1.4 1.4M3.2 14.8l1.4-1.4M13.4 4.6l1.4-1.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" /></svg>
        </button>
        <span class="gx-wb__top-divider"></span>
        <div class="gx-wb__power-top">
          <span>算力</span>
          <span class="gx-wb__power-top-val">{{ power }}</span>
        </div>
        <button class="gx-wb__recharge" @click="go({ route: '/uc_wallet' })">充值</button>
      </div>
    </header>

    <!-- 内容区 -->
    <main class="gx-wb__main">
      <div v-if="!currentItem" class="gx-wb__home">
        <div class="gx-wb__home-head">
          <div class="gx-wb__home-title">工作台</div>
          <div class="gx-wb__home-sub">从左侧选择功能模块，或使用下方快捷入口</div>
        </div>
        <div class="gx-wb__quick">
          <div
            v-for="(q, i) in quickItems"
            :key="q.label"
            class="gx-wb__quick-card"
            @mouseenter="hovQ = i"
            @mouseleave="hovQ = -1"
            @click="go(q)"
          >
            <span class="gx-wb__quick-icon" :style="quickIconStyle(q, i)">{{ q.icon }}</span>
            <div>
              <div class="gx-wb__quick-name" :style="{ color: hovQ === i ? q.color : '#1A1A2E' }">{{ q.label }}</div>
              <div class="gx-wb__quick-desc">{{ q.desc }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="gx-wb__entering">
        <div class="gx-wb__entering-icon">🚀</div>
        <div class="gx-wb__entering-title">正在进入「{{ currentItem.label }}」</div>
        <div class="gx-wb__entering-sub">功能页面即将打开，若未跳转请点击左侧导航重试</div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

const ICONS = {
  shop: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 8l2.5-5h9L16 8" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><rect x="2" y="8" width="14" height="8" rx="1" stroke="currentColor" stroke-width="1.3"/><path d="M6 16v-5h6v5" stroke="currentColor" stroke-width="1.3"/></svg>',
  goods: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 2l7 4v6l-7 4-7-4V6z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>',
  dou: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="1.3"/><path d="M6 9l5-3v6z" fill="currentColor" opacity=".6"/></svg>',
  cloud: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M13 13H5a4 4 0 010-8 4 4 0 017.6-1A3 3 0 0113 13z" stroke="currentColor" stroke-width="1.3"/><path d="M9 10v5M7 13l2 2 2-2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  wand: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M3 15l9-9M10 3l5 5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><circle cx="6" cy="5" r="1.5" fill="currentColor" opacity=".5"/><circle cx="13" cy="12" r="1.5" fill="currentColor" opacity=".5"/></svg>',
  detect: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="8" cy="8" r="5" stroke="currentColor" stroke-width="1.3"/><path d="M12 12l4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
  strat: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M3 5h12M3 9h8M3 13h5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
  box: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="3" y="7" width="12" height="9" rx="1" stroke="currentColor" stroke-width="1.3"/><path d="M3 10h12M7 7V4a2 2 0 014 0v3" stroke="currentColor" stroke-width="1.3"/></svg>',
  order: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="3" y="2" width="12" height="14" rx="1.5" stroke="currentColor" stroke-width="1.3"/><path d="M6 7h6M6 10h4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
  after: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 3C5 3 3 6 3 9c0 4 3.5 7 6 8 2.5-1 6-4 6-8 0-3-2-6-6-6z" stroke="currentColor" stroke-width="1.3"/><path d="M6 9l2.5 2.5L12 7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  addr: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 2a5 5 0 015 5c0 4-5 9-5 9S4 11 4 7a5 5 0 015-5z" stroke="currentColor" stroke-width="1.3"/><circle cx="9" cy="7" r="2" stroke="currentColor" stroke-width="1.3"/></svg>',
  purch: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M3 3h2l2.5 8h7L16 6H6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><circle cx="8" cy="14.5" r="1.5" fill="currentColor" opacity=".6"/><circle cx="13" cy="14.5" r="1.5" fill="currentColor" opacity=".6"/></svg>',
  rmb: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="2" y="4" width="14" height="10" rx="2" stroke="currentColor" stroke-width="1.3"/><path d="M2 8h14" stroke="currentColor" stroke-width="1.3"/><circle cx="6" cy="12" r="1" fill="currentColor" opacity=".5"/></svg>',
  wallet: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="2" y="4" width="14" height="11" rx="2" stroke="currentColor" stroke-width="1.3"/><path d="M12 9.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" fill="currentColor" opacity=".6"/><path d="M2 8h14" stroke="currentColor" stroke-width="1.3"/></svg>',
  role: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="6" r="3" stroke="currentColor" stroke-width="1.3"/><path d="M3 16c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
  staff: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="6.5" cy="6" r="2.5" stroke="currentColor" stroke-width="1.3"/><circle cx="12" cy="6" r="2.5" stroke="currentColor" stroke-width="1.3"/><path d="M1 16c0-3 2.5-5 5.5-5M17 16c0-3-2.5-5-5.5-5M9 11c2 0 4 1 5 3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
  profile: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="7" r="3.5" stroke="currentColor" stroke-width="1.3"/><path d="M2 17c0-4 3.1-7 7-7s7 3 7 7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
  msg: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 3h14a1 1 0 011 1v9a1 1 0 01-1 1H5l-4 3V4a1 1 0 011-1z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>'
}

export default {
  name: 'WorkbenchPage',
  data() {
    return {
      activeId: '',
      hovQ: -1,
      notifOpen: false,
      navGroups: [
        {
          title: '店铺',
          items: [
            { id: 'douyin-mgmt', label: '抖店管理', icon: ICONS.shop, route: '/new_uc_shop_manage?shop_type=1' },
            { id: 'weixin-mgmt', label: '微店管理', icon: ICONS.shop, route: '/new_uc_shop_manage?shop_type=7' }
          ]
        },
        {
          title: '运营',
          items: [
            { id: 'my-goods', label: '我的商品', icon: ICONS.goods, route: '/uc_goods' },
            { id: 'douyin-opt', label: '抖店优化', icon: ICONS.dou, route: '/uc_dd_host' },
            { id: 'cloud-lib', label: '云商品库', icon: ICONS.cloud, route: '/uc_product' },
            { id: 'goods-opt', label: '商品优化', icon: ICONS.wand, route: '/uc_optimization' },
            { id: 'detect', label: '检测管理', icon: ICONS.detect, route: '/uc_check' },
            { id: 'shelf-strat', label: '上架策略', icon: ICONS.strat, route: '/uc_shangjia' },
            { id: 'blind-box', label: '资源盲盒', icon: ICONS.box, route: '/uc_blindBox' }
          ]
        },
        {
          title: '订单',
          items: [
            { id: 'order-mgmt', label: '订单管理', icon: ICONS.order, route: '/uc_order' },
            { id: 'aftersale-mgmt', label: '售后管理', icon: ICONS.after, route: '/uc_after_sales' },
            { id: 'aftersale-addr', label: '售后地址', icon: ICONS.addr, route: '/uc_after_sale_address' },
            { id: 'purchase-mgmt', label: '采购管理', icon: ICONS.purch, route: '/uc_pdd_manage' },
            { id: 'reimburse', label: '报销管理', icon: ICONS.rmb, route: '/uc_reimbursement' }
          ]
        },
        {
          title: '财务',
          items: [{ id: 'wallet', label: '我的钱包', icon: ICONS.wallet, route: '/uc_wallet' }]
        },
        {
          title: '团队',
          items: [
            { id: 'roles', label: '岗位管理', icon: ICONS.role, route: '/uc_position' },
            { id: 'staff', label: '员工管理', icon: ICONS.staff, route: '/uc_employee' }
          ]
        },
        {
          title: '设置',
          items: [
            { id: 'profile', label: '个人设置', icon: ICONS.profile, route: '/uc_setting' },
            { id: 'messages', label: '消息中心', icon: ICONS.msg, route: '/notification' }
          ]
        }
      ],
      quickItems: [
        { icon: '🏪', label: '店铺管理', desc: '抖店/微店授权与分组', color: '#D4A946', route: '/new_uc_shop_manage' },
        { icon: '📦', label: '我的商品', desc: '商品状态与批量操作', color: '#9B8AFB', route: '/uc_goods' },
        { icon: '☁️', label: '云商品库', desc: '导入、SKU替换、裂变', color: '#8B5CF6', route: '/uc_product' },
        { icon: '🛒', label: '订单管理', desc: '拍单、关联、拦截', color: '#3FB6E0', route: '/uc_order' },
        { icon: '🛡️', label: '售后管理', desc: '退款、换货、退货', color: '#14B8A6', route: '/uc_after_sales' },
        { icon: '💰', label: '我的钱包', desc: '余额、算力、充值', color: '#22C55E', route: '/uc_wallet' },
        { icon: '🔍', label: '检测管理', desc: '关键词、图片、低价SKU', color: '#F59E0B', route: '/uc_check' },
        { icon: '📊', label: '运营大厅', desc: '店铺看板、任务大厅', color: '#FB923C', route: '/uc_shop_board' },
        { icon: '🛍️', label: '资源盲盒', desc: '自动铺货与分组', color: '#EC4899', route: '/uc_blindBox' },
        { icon: '🧾', label: '上架策略', desc: '定价与上架规则', color: '#D4A946', route: '/uc_shangjia' },
        { icon: '🤝', label: '员工管理', desc: '岗位与子账户', color: '#3FB6E0', route: '/uc_employee' },
        { icon: '⚙️', label: '个人设置', desc: '账号、密码、提醒', color: '#6A6A8A', route: '/uc_setting' }
      ]
    }
  },
  computed: {
    userinfo() {
      return this.$store.state.login.userinfo || {}
    },
    levelText() {
      const level = this.$store.state.login.user_level
      if (level === 1) return '企业版会员'
      // if (level === 2) return '企业版会员'
      return '普通会员'
    },
    avatarText() {
      const name = this.userinfo.nickname || this.userinfo.name || ''
      return name ? name[0] : '星'
    },
    power() {
      const p = this.userinfo.power !== undefined ? this.userinfo.power : (this.userinfo.power_balance !== undefined ? this.userinfo.power_balance : null)
      return p === null ? '--' : p
    },
    currentItem() {
      for (const g of this.navGroups) {
        const item = g.items.find((i) => i.id === this.activeId)
        if (item) return item
      }
      return null
    },
    crumbGroup() {
      for (const g of this.navGroups) {
        if (g.items.some((i) => i.id === this.activeId)) return g.title
      }
      return '工作台'
    },
    crumbItem() {
      return this.currentItem ? this.currentItem.label : '首页'
    },
    unreadCount() {
      const notifs = this.$store.state.notification.notifications || []
      return notifs.filter((n) => !n.isRead).length
    },
    notifs() {
      return this.$store.state.notification.notifications || []
    }
  },
  created() {
    this.$store.dispatch('notification/initNotificationWS')
  },
  methods: {
    ...mapMutations({
      OUT_LOGIN: 'login/OUT_LOGIN'
    }),
    go(item) {
      this.activeId = item.id
      this.notifOpen = false
      this.$router.push(item.route)
    },
    quickIconStyle(q, i) {
      return {
        background: `${q.color}12`,
        border: `2px solid ${q.color}35`,
        transform: this.hovQ === i ? 'scale(1.08)' : 'scale(1)'
      }
    },
    logout() {
      this.OUT_LOGIN()
      this.$message({ message: '已退出登录', type: 'success' })
      location.href = '/'
    }
  }
}
</script>

<style scoped>
.gx-wb {
  min-height: 100vh;
  background: #F0F2F8;
  font-family: 'Noto Sans SC', sans-serif;
  position: relative;
}
.gx-wb__sidebar {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 220px;
  z-index: 50;
  display: flex;
  flex-direction: column;
  background: #EEF1F6;
  border-right: 1px solid #DDE2EC;
}
.gx-wb__logo {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 16px 18px;
  border-bottom: 1px solid #DDE2EC;
  flex-shrink: 0;
}
.gx-wb__logo-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: linear-gradient(135deg, #D4A946, #E8C778);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 12px rgba(212, 169, 70, .4);
}
.gx-wb__logo-name {
  font-family: 'Noto Serif SC', serif;
  font-size: 19px;
  font-weight: 700;
  color: #1A1A2E;
}
.gx-wb__user {
  padding: 14px 16px;
  border-bottom: 1px solid #DDE2EC;
  flex-shrink: 0;
}
.gx-wb__user-row {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 8px;
}
.gx-wb__user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3FB6E0, #FFFFFF);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: #1A1A2E;
  flex-shrink: 0;
  overflow: hidden;
}
.gx-wb__user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-wb__user-info {
  min-width: 0;
}
.gx-wb__user-name {
  font-size: 13px;
  color: #1A1A2E;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gx-wb__user-level {
  display: inline-flex;
  align-items: center;
  margin-top: 3px;
  background: rgba(250, 87, 87, .1);
  border: 1px solid rgba(250, 87, 87, .25);
  border-radius: 4px;
  padding: 1px 7px;
  font-size: 11px;
  color: #fa5757;
  letter-spacing: .04em;
}
.gx-wb__power {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #fa5757;
  display: flex;
  align-items: center;
  gap: 4px;
}
.gx-wb__power-label {
  color: #6A6A8A;
}
.gx-wb__nav {
  flex: 1;
  overflow-y: auto;
  padding: 8px 8px;
  scrollbar-width: none;
}
.gx-wb__nav::-webkit-scrollbar {
  display: none;
}
.gx-wb__group {
  margin-bottom: 6px;
}
.gx-wb__group-title {
  font-size: 11px;
  color: #6A6A8A;
  text-transform: uppercase;
  letter-spacing: .1em;
  padding: 8px 8px 4px;
}
.gx-wb__item {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 0 8px;
  border-radius: 8px;
  border: none;
  border-left: 3px solid transparent;
  background: transparent;
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #5C6B73;
  text-align: left;
  flex-shrink: 0;
  margin-bottom: 1px;
  transition: all .18s ease;
}
.gx-wb__item:hover {
  background: rgba(255, 255, 255, .72);
  color: #1A1A2E;
}
.gx-wb__item--on {
  background: #FFFFFF;
  border-left-color: #fa5757;
  color: #1A1A2E;
  font-weight: 500;
}
.gx-wb__item-icon {
  display: inline-flex;
  flex-shrink: 0;
  color: inherit;
}
.gx-wb__logout {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  border-top: 1px solid #DDE2EC;
  background: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #6A6A8A;
  transition: color .18s;
  text-align: left;
}
.gx-wb__logout:hover {
  color: #F87171;
}
.gx-wb__topbar {
  position: fixed;
  top: 0;
  left: 220px;
  right: 0;
  height: 60px;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  background: #F6F7FA;
  border-bottom: 1px solid #DDE2EC;
}
.gx-wb__crumb {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #6A6A8A;
}
.gx-wb__crumb-arrow {
  color: #9CA3B5;
}
.gx-wb__crumb-current {
  color: #1A1A2E;
  font-weight: 500;
}
.gx-wb__top-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
.gx-wb__icon-btn {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #4A4A6A;
  transition: all .18s ease;
}
.gx-wb__icon-btn:hover {
  background: #EEF1F6;
  color: #1A1A2E;
}
.gx-wb__bell-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #F87171;
  border: 2px solid #F6F7FA;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'JetBrains Mono', monospace;
  font-size: 9px;
  font-weight: 700;
  color: #fff;
  pointer-events: none;
}
.gx-wb__bell-wrap {
  position: relative;
}
.gx-wb__notif {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 300px;
  border-radius: 12px;
  overflow: hidden;
  z-index: 100;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .2);
  box-shadow: 0 16px 48px rgba(15, 23, 42, .16);
}
.gx-wb__notif-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px 10px;
  border-bottom: 1px solid #DDE2EC;
  font-size: 13px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-wb__notif-head button {
  background: none;
  border: none;
  cursor: pointer;
  color: #6A6A8A;
  padding: 0;
}
.gx-wb__notif-item {
  padding: 11px 16px;
  border-bottom: 1px solid rgba(212, 169, 70, .07);
  display: flex;
  gap: 10px;
  align-items: flex-start;
}
.gx-wb__notif-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #FB923C;
  margin-top: 5px;
  flex-shrink: 0;
}
.gx-wb__notif-text {
  font-size: 12px;
  color: #1A1A2E;
  line-height: 1.55;
}
.gx-wb__notif-time {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: #6A6A8A;
  margin-top: 3px;
}
.gx-wb__notif-empty {
  padding: 32px 0;
  text-align: center;
  font-size: 12px;
  color: #6A6A8A;
}
.gx-wb__notif-all {
  width: 100%;
  padding: 10px 16px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  color: #4A4A6A;
}
.gx-wb__top-divider {
  width: 1px;
  height: 20px;
  background: rgba(212, 169, 70, .15);
  margin: 0 8px;
}
.gx-wb__power-top {
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
}
.gx-wb__power-top > span:first-child {
  color: #6A6A8A;
}
.gx-wb__power-top-val {
  color: #fa5757;
  font-weight: 600;
}
.gx-wb__recharge {
  margin-left: 8px;
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  cursor: pointer;
  border-radius: 6px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #F4F6F8;
}
.gx-wb__main {
  margin-left: 220px;
  padding-top: 60px;
  min-height: 100vh;
  position: relative;
  z-index: 10;
}
.gx-wb__main > div {
  padding: 24px;
}
.gx-wb__home-head {
  margin-bottom: 20px;
}
.gx-wb__home-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 24px;
  font-weight: 600;
  color: #1A1A2E;
  margin-bottom: 6px;
}
.gx-wb__home-sub {
  font-size: 13px;
  color: #6A6A8A;
}
.gx-wb__quick {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}
.gx-wb__quick-card {
  border-radius: 12px;
  padding: 18px 16px 14px;
  cursor: pointer;
  background: #FFFFFF;
  border: 2px solid #E0E0EC;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-wb__quick-card:hover {
  transform: translateY(-4px);
}
.gx-wb__quick-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
  transition: transform .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-wb__quick-name {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 2px;
  transition: color .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-wb__quick-desc {
  font-size: 11px;
  color: #6A6A8A;
}
.gx-wb__entering {
  text-align: center;
  padding: 80px 24px !important;
  border-radius: 16px;
  background: linear-gradient(135deg, #FFFFFF, rgba(15, 29, 66, .25));
  border: 1px solid #E1E5EE;
}
.gx-wb__entering-icon {
  font-size: 56px;
  margin-bottom: 16px;
}
.gx-wb__entering-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 18px;
  color: #4A4A6A;
  margin-bottom: 8px;
}
.gx-wb__entering-sub {
  font-size: 13px;
  color: #6A6A8A;
}
@media (max-width: 1100px) {
  .gx-wb__quick {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
